<template>
  <v-card :color="$vuetify.theme.dark ? '#363636' : '#fafafa'" height="100%" outlined class="card-back pa-3">
    <v-row>
      <v-col cols="4">
        <div style="background-color: #084776; border-radius: 4px" class="text-center py-3">
          <v-icon size="32" color="white">{{ item.icon }}</v-icon>
        </div>
      </v-col>
      <v-col cols="8">
        <div class="text-h5 font-weight-bold">{{ number }}</div>
        <div class="grey--text">{{ item.title }}</div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "StatisticCard",
  props: {
    item: {
      type: Object
    },
    number: {
      type: Number
    }
  }
}
</script>

<style scoped>

</style>
